



















import { stringToNumber } from "@/utility/CommonHelper";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SuhuBadan extends Vue {
  @Prop() setSuhu: number = null;
  @Prop() setLabel!: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) readonly?: boolean;
  @Ref() readonly inputElement: HTMLInputElement;
  @Prop({ default: () => [] }) errorMessages?: string[];
  // suhu = "";
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [v => this.cek(v) || this.message()];
  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (!this.setSuhu) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setSuhu")
  valSuhu(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("suhu", stringToNumber(val));
    // this.setSuhu = val;
  }

  cek(v) {
    this.setSuhu = stringToNumber(v);

    if (Number(v) > 100) {
      this.msg = "*Suhu Badan " + v + ", Anda yakin?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }
}
